/* Nav labels, hrefs and grouping mirror bkvenergy.com exactly.
   Source: live DOM read of https://bkvenergy.com/ (2026-09-28). */

export const HeaderTitleArray = [
    {
        title: "Plans",
        link: "https://bkvenergy.com/compare-texas-electricity-plans/",
    },
    {
        title: "Benefits",
        link: "https://bkvenergy.com/bkv-energy-plus/",
    },
    {
        title: "Refer",
        link: "https://bkvenergy.com/referral-program/",
    },
    {
        title: "Blog",
        link: "https://bkvenergy.com/blog/",
    },
    {
        title: "Support",
        link: "https://bkvenergy.com/support/",
    },
    {
        title: "Pay Bill",
        link: "https://bkvenergy.com/quickpay/",
    },
    {
        title: "Login",
        link: "https://bkvenergy.com/account/login",
    },
];

export const ElectricObject = {
    "Plans": [
        {
            title: 'BLUEBONNET PLAN',
            link: 'https://bkvenergy.com/bluebonnet-plan/',
        },
        {
            title: '100% RENEWABLE',
            link: 'https://bkvenergy.com/renewable-electricity-plans/',
        },
        {
            title: 'FOR HOMES',
            link: 'https://bkvenergy.com/homeowner-electricity-plans/',
        },
        {
            title: 'FOR APARTMENTS',
            link: 'https://bkvenergy.com/apartment-electricity-plans/',
        },
        {
            title: 'FIRST RESPONDER & VETERAN DISCOUNT',
            link: 'https://bkvenergy.com/first-responder-and-veteran-discount/',
        },
        {
            title: 'NO DEPOSIT FOR SENIORS (65+)',
            link: 'https://bkvenergy.com/no-deposit-electricity-65-and-older/',
        },
        {
            title: 'SAME DAY ELECTRICITY SERVICE',
            link: 'https://bkvenergy.com/same-day-electricity/',
        },
    ],
    "Service Areas": [
        {
            title: 'DALLAS',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-dallas/',
        },
        {
            title: 'HOUSTON',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-houston/',
        },
        {
            title: 'CORPUS',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-corpus-christi/',
        },
        {
            title: 'LUBBOCK',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-lubbock/',
        },
        {
            title: 'FORT WORTH',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-fort-worth/',
        },
        {
            title: 'WACO',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-waco/',
        },
        {
            title: 'ABILENE',
            link: 'https://bkvenergy.com/find-power/electricity-provider-in-abilene/',
        },
        {
            title: 'VIEW ALL',
            link: 'https://bkvenergy.com/find-power/',
        },
    ],
};

export const EarnObject = {
    "BKV Energy Plus": [
        {
            title: 'ELECTROSHARE',
            link: 'https://bkvenergy.com/electroshare/',
        },
        {
            title: 'REDUCE YOUR RATE',
            link: 'https://bkvenergy.com/reduce-your-rate/',
        },
        {
            title: 'SAVE NOW PAY LATER',
            link: 'https://bkvenergy.com/save-now-pay-later/',
        },
        {
            title: 'SPARK ALERTS',
            link: 'https://bkvenergy.com/spark-alerts/',
        },
        {
            title: 'VOLTPOINTS',
            link: 'https://bkvenergy.com/voltpoints/',
        },
        {
            title: 'CONTRACT CONSULTATION',
            link: 'https://bkvenergy.com/contract-consultation/',
        },
        {
            title: '30-DAY POWER PILOT',
            link: 'https://bkvenergy.com/30-day-power-pilot/',
        },
        {
            title: 'BILL SCANNER',
            link: 'https://bill-reader.bkvenergy.com/',
        },
    ],
    "Referral Program": [
        {
            title: 'HOW IT WORKS',
            link: 'https://bkvenergy.com/referral-program/#how',
        },
        {
            title: 'REFERRAL TIPS',
            link: 'https://bkvenergy.com/referral-program/#tips',
        },
        {
            title: 'START REFERRING',
            link: 'https://bkvenergy.com/referral-program/',
        },
    ],
};

export const ReferralsObject = {
    "Referral Program": [
        {
            title: 'HOW IT WORKS',
            link: 'https://bkvenergy.com/referral-program/#how',
        },
        {
            title: 'REFERRAL TIPS',
            link: 'https://bkvenergy.com/referral-program/#tips',
        },
        {
            title: 'START REFERRING',
            link: 'https://bkvenergy.com/referral-program/',
        },
    ],
};

export const ResourcesObject = {
    'Learning Center': [
        {
            title: 'THE ENERGY INDUSTRY',
            link: 'https://bkvenergy.com/learning-center-topic/how-the-energy-industry-works/',
        },
        {
            title: 'ELECTRICITY GENERATION',
            link: 'https://bkvenergy.com/learning-center-topic/energy-production/',
        },
        {
            title: 'TEXAS ENERGY MARKET',
            link: 'https://bkvenergy.com/learning-center-topic/deregulation-and-the-texas-market/',
        },
        {
            title: 'SUSTAINABILITY',
            link: 'https://bkvenergy.com/learning-center-topic/sustainability-and-the-net-zero-initiative/',
        },
    ],
    "Blog": [
        {
            title: 'REDUCE YOUR ELECTRIC BILL',
            link: 'https://bkvenergy.com/blog/category/bills-and-savings/',
        },
        {
            title: 'ENERGY NEWS',
            link: 'https://bkvenergy.com/blog/category/energy-news/',
        },
        {
            title: 'LIVING IN TEXAS',
            link: 'https://bkvenergy.com/blog/category/living-in-texas/',
        },
        {
            title: 'SAFETY GUIDES',
            link: 'https://bkvenergy.com/blog/tag/safety-tips/',
        },
    ],
    "Newsroom": [
        {
            title: 'BKVE IN THE NEWS',
            link: 'https://bkvenergy.com/in-the-news-category/media-coverage/',
        },
        {
            title: 'PRESS RELEASES',
            link: 'https://bkvenergy.com/in-the-news-category/press-releases/',
        },
        {
            title: 'MEDIA ASSETS',
            link: 'https://bkvenergy.com/media-assets/',
        },
    ],
};

export const SupportObject = {
    "Account Help": [
        {
            title: 'TRANSFER OF SERVICE',
            link: 'https://bkvenergy.com/transfer-of-service/',
        },
    ],
    "Support Center": [
        {
            title: 'BILLING & PAYMENTS',
            link: 'https://bkvenergy.com/support-category/billing-payments/',
        },
        {
            title: 'ACCOUNT SETUP',
            link: 'https://bkvenergy.com/support-category/sign-up-accounts/',
        },
        {
            title: 'ELECTRICITY SERVICES',
            link: 'https://bkvenergy.com/support-category/bkve-electricity-services/',
        },
        {
            title: 'ENERGY SAVING TIPS',
            link: 'https://bkvenergy.com/blog/category/bills-and-savings/',
        },
    ],
    "Contact us": [
        {
            title: 'REPORT AN OUTAGE',
            link: 'https://bkvenergy.com/outage/',
        },
        {
            title: 'CHAT WITH AN AGENT',
            link: 'https://bkvenergy.com/contact-us/',
        },
    ],
};

/* Maps a top-level nav title to its dropdown content.
   Titles absent here (Pay Bill, Login) have no dropdown. */
export const MENU_BY_TITLE = {
    "Plans": ElectricObject,
    "Benefits": EarnObject,
    "Refer": ReferralsObject,
    "Blog": ResourcesObject,
    "Support": SupportObject,
};

/* Each dropdown group heading links to the parent's landing page for that group. */
const GROUP_LINKS = {
    "Plans": "https://bkvenergy.com/compare-texas-electricity-plans/",
    "Service Areas": "https://bkvenergy.com/find-power/",
    "BKV Energy Plus": "https://bkvenergy.com/bkv-energy-plus/",
    "Referral Program": "https://bkvenergy.com/referral-program/",
    "Learning Center": "https://bkvenergy.com/learning-center/",
    "Blog": "https://bkvenergy.com/blog/",
    "Newsroom": "https://bkvenergy.com/newsroom/",
    "Account Help": "https://bkvenergy.com/support/",
    "Support Center": "https://bkvenergy.com/support/",
    "Contact us": "https://bkvenergy.com/contact-us/",
};

export const getHeaderLink = (val) => GROUP_LINKS[val];
